/**
 * FolderGrid component - Grid container for folder cards
 */

import React from 'react';
import { DriveFolder } from '../../types/outreachTemplates';
import FolderCard from './FolderCard';

interface FolderGridProps {
  folders: DriveFolder[];
}

const FolderGrid: React.FC<FolderGridProps> = ({ folders }) => {
  return (
    <div className="folder-grid">
      {folders.map((folder) => (
        <FolderCard key={folder.id} folder={folder} />
      ))}
    </div>
  );
};

export default FolderGrid;

